import store from '@/store'
import { EAuthActions, EAuthMutations } from '@/store/authStore/AuthStoreTypes'
import { EStoreModules } from '@/store/storeType'
import { EUserActions } from '@/store/userStore/UserStoreTypes'
import type { MenuItemType } from '@/types/MenuItem'
import { ESitesPerm } from '@/types/permissions/EventsPermissionsEnum'
import { userHasPermission } from '@/utils/permissionsUtils'
import { computed, type ComputedRef } from 'vue'
import { EDetectionsPerm } from '../types/permissions/DetectionsPermissionsEnum'
import { EWebSocketPerm } from '../types/permissions/WebSocketPermissionsEnum'
import {
    DETECTION_ROUTE,
    DEVICE_ROUTE,
    EVENTS_ROUTE,
    MY_ACCOUNT_ROUTE,
    PRESENCE_ROUTE,
    TRIPS_PERSONS_ROUTE,
    TRIPS_SHUTTLES_ROUTE
} from './routes'
import { MY_ACCOUNT_ROUTE_NAME } from './routing/accountRoutes'
import { adminMenu } from './routing/adminRouting/adminMenu'
import { ECheckpointRoutesNamesValues } from './routing/checkpointsRoutes'
import {
    EDetectionsRoutesNamesValues,
    EPresencesRoutesNamesValues,
    ETripsPersonsRoutesNamesValues,
    ETripsShuttlesRoutesNamesValues
} from './routing/detectionsRoutes'
import { EDeviceRoutesNamesValues } from './routing/devicesRoutes'
import { EEventRoutesNamesValues } from './routing/eventsRoutes'
import { HOME_ROUTE_NAME } from './routing/homeRoutes'

export const menuRoutesTop: ComputedRef<MenuItemType[]> = computed(() => [
    {
        icon: 'gear',
        label: 'menu.devices',
        to: DEVICE_ROUTE,
        names: EDeviceRoutesNamesValues
    },
    {
        icon: 'calendar-days',
        label: 'menu.events',
        to: EVENTS_ROUTE,
        permissions: userHasPermission(ESitesPerm.EVENTS_VIEW),
        names: [...EEventRoutesNamesValues, ...ECheckpointRoutesNamesValues, HOME_ROUTE_NAME]
    },
    {
        icon: 'eye',
        label: 'menu.detections',
        to: DETECTION_ROUTE,
        permissions: userHasPermission(EWebSocketPerm.WEBSOCKET_ACCESS),
        names: EDetectionsRoutesNamesValues
    },
    {
        icon: 'eye',
        label: 'menu.presences',
        to: PRESENCE_ROUTE,
        permissions: userHasPermission(EDetectionsPerm.DETECTIONS_VIEW),
        names: EPresencesRoutesNamesValues
    },

    {
        icon: 'person-walking-luggage',
        label: 'menu.personsTrips',
        to: TRIPS_PERSONS_ROUTE,
        permissions: userHasPermission(EDetectionsPerm.DETECTIONS_VIEW),
        names: ETripsPersonsRoutesNamesValues
    },
    {
        icon: 'bus',
        label: 'menu.shuttlesTrips',
        to: TRIPS_SHUTTLES_ROUTE,
        permissions: userHasPermission(EDetectionsPerm.DETECTIONS_VIEW),
        names: ETripsShuttlesRoutesNamesValues
    },
    ...adminMenu.value
])

export const menuRoutesBottom: MenuItemType[] = [
    /* {
        icon: 'comments',
        label: 'menu.supportFaq',
        to: SUPPORTFAQ_ROUTE,
        names: ['supportFaqTable', 'supportFaqDetail']
    } */
]

export const menuAccountItems = computed(() => ({
    myAccount: {
        icon: 'user',
        label: store.state.authentication.me.name,
        to: MY_ACCOUNT_ROUTE,
        names: [MY_ACCOUNT_ROUTE_NAME],
        withoutTranslation: true
    },
    impersonate: {
        icon: 'user-slash',
        label: 'menu.deimpersonate',
        click: () => {
            store
                .dispatch(`${EStoreModules.USER}/${[EUserActions.DEIMPERSONATION_USER]}`)
                .then(() => store.dispatch(`${EStoreModules.AUTHENTICATION}/${[EAuthActions.ME]}`))
        },
        names: []
    },
    disconnect: {
        icon: 'right-from-bracket',
        label: 'menu.logout',
        to: 'logout',
        click: () => store.dispatch(`${EStoreModules.AUTHENTICATION}/${[EAuthMutations.LOGOUT]}`),
        names: []
    }
}))
